module.exports = __webpack_public_path__ + "static/ux_7_eg-ce2e18e74f36a3ca6a82415668cb63c4.png";